var axios = require('axios');

var scrape = require('./scrape');

var parse = require('./parse');

module.exports = {
  fetch: function fetch(skywardURL) {
    return function (auth) {
      return function (course, bucket) {
        return scrape(axios, skywardURL)(auth, course, bucket);
      };
    };
  },
  getData: parse
};